import React from "react";
import { toast } from "react-toastify";
import { MDBIcon } from "mdbreact";
import TextField from "@material-ui/core/TextField";
import Swal from "sweetalert2";

import QuestionTable from "./components/QuestionTable";
import QuestionModal from "./components/QuestionModal";
import QuillComponent from "../../Components/QuillEditor";
import { ActivityIndicator } from "../../Components/ActivityIndicator";
import { AudioModal } from "../../Components/AudioModal";
import modalStyles from "../../Components/AudioModal/index.module.css";

import { saveContentData, getLastVersion } from "./Functions/Save";
import htmlContent from "./Functions/htmlContent";

import { clone, obJLength } from "../../Utils/arrObj";
import { Elastic } from "../../Services/elastic";

import { userContext } from "../../Context/user";

import { userType } from "../../Constants";
import { db, storage } from "../../fire";
import { Routes } from "../../Routes";

import styles from "./index.module.css";

// Html
let Quill = require("quill2");
let Parchment = Quill.import("parchment");

const config = {
  scope: Parchment.Scope.INLINE,
};
let FormatBlot = new Parchment.ClassAttributor("custom", "ql-custom", config);
Quill.register(FormatBlot, true);

const Topic = () => ({
  data: "",
  itens: [
    {
      data: "",
      itens: [
        {
          type: "content",
          data: "",
          htmls: "",
          steps: "",
        },
      ],
    },
  ],
});

const defaultFormContent = () => [
  {
    type: "title",
    data: "",
  },
  {
    type: "sumary",
    itens: [
      {
        data: "",
        itens: ["", "", "", ""],
      },
      {
        data: "",
        itens: ["", "", "", ""],
      },
      {
        data: "",
        itens: ["", "", "", ""],
      },
      {
        data: "",
        itens: ["", "", "", ""],
      },
      {
        data: "",
        itens: ["", "", "", ""],
      },
    ],
  },
  {
    type: "goals",
    itens: ["", "", "", "", "", ""],
  },
  {
    type: "comment",
    data: "",
  },
  {
    type: "topic",
    itens: [Topic()],
  },
  {
    type: "thought-time",
    itens: ["", "", "", "", "", "", ""],
  },
  {
    type: "glossary",
    itens: [
      {
        word: "",
        meaning: "",
      },
      {
        word: "",
        meaning: "",
      },
      {
        word: "",
        meaning: "",
      },
      {
        word: "",
        meaning: "",
      },
      {
        word: "",
        meaning: "",
      },
      {
        word: "",
        meaning: "",
      },
      {
        word: "",
        meaning: "",
      },
      {
        word: "",
        meaning: "",
      },
      {
        word: "",
        meaning: "",
      },
      {
        word: "",
        meaning: "",
      },
    ],
  },
  {
    type: "bibliography",
    itens: [
      {
        text: "",
        link: "",
      },
      {
        text: "",
        link: "",
      },
      {
        text: "",
        link: "",
      },
      {
        text: "",
        link: "",
      },
      {
        text: "",
        link: "",
      },
      {
        text: "",
        link: "",
      },
    ],
  },
];

class Editor extends React.Component {
  state = {
    currentViewOption: "modulos",
    currentEditingOption: undefined,
    modules: [],
    revisions: [],
    allMatters: [],
    activeMatter: undefined,
    loadingModules: true,
    isFinishing: false,
    isChangingApprovedStatus: false,
    isSearching: false,
    service: null,
    isQuestionModalOpen: false,
    formContent: [],
    selectedQuestions: {},
    questionsToAdd: [],
  };

  formContent = {};
  editors = {};
  first = true;
  addedTopic = false;
  allowAll = false;

  componentDidMount() {
    this.getData();

    console.log(
      "Pedido de Serviço: ",
      this?.props?.location?.state?.service?.codigo
    );

    if (!this?.props?.location?.state?.service?.codigo) {
      toast(
        "Atenção: Nenhum Pedido de Serviço foi encontrado, tente fechar essa aba e abrir novamente.",
        { type: "error" }
      );
      return;
    } else if (!this?.props?.location?.state?.user?.id) {
      toast(
        "Atenção: Nenhum Usuario foi encontrado, tente fechar essa aba e abrir novamente.",
        { type: "error" }
      );
      return;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.formContent[4]) return;
    if (!document.getElementById("editor-container0")) return;
    if (
      !this.allowAll &&
      !this.first &&
      !this.addedTopic &&
      prevState.activeMatter === this.state.activeMatter
    )
      return;

    let allow = [];

    if (this.allowAll) {
      this.state.formContent[4].itens.forEach((item, key) =>
        allow.push(key.toString())
      );
    } else if (this.first) {
      allow.push("0");
    } else if (this.addedTopic) {
      allow.push((this.state.formContent[4].itens.length - 1).toString());
    }

    this.first = false;
    this.addedTopic = false;
    this.allowAll = false;

    if (
      prevState.activeMatter &&
      prevState.activeMatter !== this.state.activeMatter
    ) {
      let prevTot =
        this.formContent[prevState.activeMatter][4].itens.length - 1;
      let actualTot = this.state.formContent[4].itens.length - 1;

      if (prevTot < actualTot) {
        for (let i = prevTot + 1; i <= actualTot; i++) {
          allow.push(i.toString());
        }
      }
    }

    for (let key in this.state.formContent[4].itens) {
      if (!document.getElementById("editor-container" + key)) continue;

      const item = clone(
        this.state.formContent[4].itens[key].itens[0].itens[0]
      );

      if (allow.includes(key) || !this.editors[key]) {
        this.editors[key] = new Quill("#editor-container" + key, {
          modules: {
            table: true,
            toolbar: {
              container: "#toolbar-container" + key,
              handlers: {
                customoption: function (form) {
                  this.quill.format("custom", form);
                },
              },
            },
          },
          theme: "snow",
        });

        this.editors[key].on("text-change", () => {
          const editorContent = document.getElementById(
            "editor-container" + key
          )?.firstElementChild;

          if (!editorContent) return;

          this.handleContentChange(
            "subtopic",
            {
              data: this.editors[key].getText(),
              htmls: editorContent.innerHTML,
              steps: JSON.stringify(this.editors[key].getContents()),
            },
            [4, key]
          );
        });

        const table = this.editors[key].getModule("table");

        document
          .querySelector("#insert-table" + key)
          .addEventListener("click", () => {
            table.insertTable(2, 2);
          });
        document
          .querySelector("#insert-row-above" + key)
          .addEventListener("click", () => {
            table.insertRowAbove();
          });
        document
          .querySelector("#insert-row-below" + key)
          .addEventListener("click", () => {
            table.insertRowBelow();
          });
        document
          .querySelector("#insert-column-left" + key)
          .addEventListener("click", () => {
            table.insertColumnLeft();
          });
        document
          .querySelector("#insert-column-right" + key)
          .addEventListener("click", () => {
            table.insertColumnRight();
          });
        document
          .querySelector("#delete-row" + key)
          .addEventListener("click", () => {
            table.deleteRow();
          });
        document
          .querySelector("#delete-column" + key)
          .addEventListener("click", () => {
            table.deleteColumn();
          });
        document
          .querySelector("#delete-table" + key)
          .addEventListener("click", () => {
            table.deleteTable();
          });
      }

      if (
        this.state.activeMatter &&
        this.formContent[this.state.activeMatter]
      ) {
        if (
          this.formContent[this.state.activeMatter][4].itens[key].itens[0]
            .itens[0].steps
        ) {
          this.editors[key].setContents(
            JSON.parse(
              this.formContent[this.state.activeMatter][4].itens[key].itens[0]
                .itens[0].steps
            ),
            "api"
          );
        }
      } else if (item.data && item.steps) {
        this.editors[key].setContents(JSON.parse(item.steps), "api");
      } else {
        this.editors[key].setContents([], "api");
      }
    }
  }

  closeModal = () => {
    this.setState({ isQuestionModalOpen: false });
  };

  getData = async () => {
    try {
      const { service } = this.props.location.state;
      this.setState({ loadingModules: true });
      const serviceRef = await db
        .collection("pedidosDeServico")
        .doc(service.id)
        .get();

      const path = serviceRef.data();

      const modulesRef = path.objetoResultadoRef.collection("modulos");
      const revisionstRef = path.objetoResultadoRef.collection("revisoes");
      let selectedQuestions = {};

      const [modules, revisions] = await Promise.all(
        [modulesRef, revisionstRef].map(async (ref) => {
          const docRef = await ref.get();

          return Promise.all(
            docRef.docs.map(async (doc) => {
              const docSearch = await db
                .doc(
                  `materias/${doc.id.substr(0, 4)}/pilhas/${doc.id.substr(
                    0,
                    7
                  )}/${doc.id.charAt(7) === "m" ? "modulos" : "revisoes"}/${
                    doc.id
                  }`
                )
                .get();

              let docData;

              if (docSearch.exists) {
                docData = docSearch.data();

                if (!selectedQuestions[doc.id]) selectedQuestions[doc.id] = {};

                const questoes = await Promise.all(
                  docData.questoes
                    .filter((q) => q)
                    .map(async (questaoId) => {
                      if (questaoId.indexOf("/") !== -1) {
                        questaoId = questaoId.slice(
                          questaoId.lastIndexOf("/") + 1
                        );
                      }

                      const questaoRef = await db
                        .collection("questoes")
                        .doc(questaoId)
                        .get();

                      if (!questaoRef.exists) return null;

                      return questaoRef.data();
                    })
                );

                for (const pos in questoes) {
                  if (!questoes[pos]) continue;

                  selectedQuestions[doc.id][questoes[pos].codigo] =
                    questoes[pos];
                }
              } else {
                docData = doc.data();
              }

              return {
                id: doc.id,
                ...docData,
              };
            })
          );
        })
      );

      this.setState({
        modules,
        revisions,
        allMatters: [...modules, ...revisions],
        serviceid: service.id,
        service: path,
        selectedQuestions,
      });
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ loadingModules: false });
    }
  };

  setCurrentView = async (viewOption, matter) => {
    if (
      !matter?.id ||
      (this.state.activeMatter && this.state.activeMatter === matter?.id)
    )
      return;

    if (this.state.activeMatter) {
      const result = await Swal.fire({
        title: "Deseja salvar os dados antes de mudar de modulo?",
        html:
          "O botão de salvar funciona apenas para o modulo atual, deseja salvar o conteudo antes de mudar de modulo?<br><br><strong>Caso não salve, todo o conteudo será perdido.</strong>",
        icon: "warning",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Salvar",
        cancelButtonText: "Continuar sem salvar",
      });

      if (result.dismiss && result.dismiss !== "cancel") return;

      if (!result.value) {
        this.formContent[this.state.activeMatter] = clone(
          this.state.formContent
        );
      } else {
        const saveResult = await this.saveChanges({
          showConfimModal: true,
        });
        if (!saveResult) return;
      }
    }

    if (!this.formContent[matter.id]) {
      const lastVersion = await getLastVersion(matter.id);

      if (lastVersion) {
        this.formContent[matter.id] = lastVersion.data;
      } else {
        this.formContent[matter.id] = defaultFormContent();
      }

      const hasBibliography = this.formContent[matter.id].find(
        (content) => content.type === "bibliography"
      );

      if (!hasBibliography) {
        this.formContent[matter.id].push({
          type: "bibliography",
          itens: [
            {
              text: "",
              link: "",
            },
            {
              text: "",
              link: "",
            },
            {
              text: "",
              link: "",
            },
            {
              text: "",
              link: "",
            },
            {
              text: "",
              link: "",
            },
            {
              text: "",
              link: "",
            },
          ],
        });
      }

      let actualMudule;

      if (matter.id.charAt(matter.id.length - 2) === "m") {
        actualMudule = this.state.modules.find(
          (modulo) => modulo.id === matter.id
        );
      } else {
        actualMudule = this.state.revisions.find(
          (modulo) => modulo.id === matter.id
        );
      }

      const hasSubject = this.formContent[matter.id].find(
        (content) => content.type === "subject"
      );

      if (!hasSubject) {
        const isRevision = matter.id === this.state.revisions[0].id;

        let data = "";

        if (isRevision) {
          data =
            this?.props?.location?.state?.service.objetoResultadoRef?.assunto ||
            "";
        } else {
          data = actualMudule?.nome || "";
        }

        this.formContent[matter.id].push({
          type: "subject",
          data,
        });
      }

      const firstName = this?.props?.location?.state?.user?.primeiroNome;
      const lastName = this?.props?.location?.state?.user?.sobrenome;
      const name = `${firstName} ${lastName}`;

      const hasInstructor = this.formContent[matter.id].find(
        (content) => content.type === "instructor"
      );

      if (!hasInstructor) {
        this.formContent[matter.id].push({
          type: "instructor",
          data: actualMudule?.profAutor || name,
        });
      }

      const hasReviewer = this.formContent[matter.id].find(
        (content) => content.type === "reviewer"
      );

      if (!hasReviewer) {
        this.formContent[matter.id].push({
          type: "reviewer",
          data: actualMudule?.profRevisor || "",
        });
      }
    }

    this.setState({
      currentViewOption: viewOption,
      activeMatter: matter?.id,
      formContent: this.formContent[matter.id],
      currentEditingOption: this.state.currentEditingOption || 0,
    });
  };

  setCurrentEditingOption = (option) => {
    if (this.state.currentEditingOption === option) return;

    this.allowAll = true;
    this.setState({ currentEditingOption: option });
  };

  renderModulesHeader = () => {
    const {
      currentViewOption,
      currentEditingOption,
      modules,
      activeMatter,
    } = this.state;

    return (
      <div
        className={`${styles["header-container"]}  ${styles["modules-header"]}`}
      >
        <h2 className={`${styles["header-title"]} with-decoration`}>Módulos</h2>
        <div className={styles.header}>
          {modules.map((modulo, index) => {
            return (
              <button
                key={modulo.id}
                isactive={activeMatter === modulo.id ? "true" : ""}
                onClick={() => this.setCurrentView("modulos", modulo)}
              >
                <h2>M {index + 1}</h2>
                <p title={modulo.nome}>
                  {modulo.nome && modulo.nome.length >= 35
                    ? `${modulo.nome.slice(0, 35)}...`
                    : modulo.nome}
                </p>
              </button>
            );
          })}
        </div>
        {currentViewOption === "modulos" && currentEditingOption >= 0 && (
          <div className={styles["buttons-container"]}>
            <button
              isactive={currentEditingOption === 0 ? "true" : "false"}
              onClick={() => this.setCurrentEditingOption(0)}
            >
              conteúdo
            </button>
            <button
              isactive={currentEditingOption === 1 ? "true" : "false"}
              onClick={() => this.setCurrentEditingOption(1)}
            >
              questões atuais (
              {
                Object.keys(
                  this.state.selectedQuestions[this.state.activeMatter] || {}
                ).length
              }
              )
            </button>
            <button
              isactive={currentEditingOption === 2 ? "true" : "false"}
              onClick={() => this.setCurrentEditingOption(2)}
            >
              +add questões
            </button>
          </div>
        )}
      </div>
    );
  };

  renderRevisionsHeader = () => {
    const {
      currentViewOption,
      currentEditingOption,
      revisions,
      activeMatter,
    } = this.state;

    return (
      <div
        className={`${styles["header-container"]} ${styles["revisions-header"]}`}
      >
        <h2 className={`${styles["header-title"]} with-decoration`}>
          Revisões
        </h2>
        <div className={styles.header}>
          {revisions[0] && (
            <button
              key={revisions[0].matterID}
              isactive={activeMatter === revisions[0].id ? "true" : ""}
              onClick={() => this.setCurrentView("revisoes", revisions[0])}
              style={{ maxWidth: "33%" }}
            >
              <h2>R 1</h2>
              <p title={revisions[0].nome}>
                {revisions[0].nome && revisions[0].nome.length >= 35
                  ? `${revisions[0].nome.slice(0, 35)}...`
                  : revisions[0].nome}
              </p>
            </button>
          )}
        </div>
        {currentViewOption === "revisoes" && currentEditingOption >= 0 && (
          <div className={styles["buttons-container"]}>
            <button
              isactive={currentEditingOption === 0 ? "true" : "false"}
              onClick={() => this.setCurrentEditingOption(0)}
            >
              conteúdo
            </button>
            <button
              isactive={currentEditingOption === 1 ? "true" : "false"}
              onClick={() => this.setCurrentEditingOption(1)}
            >
              questões atuais (
              {
                Object.keys(
                  this.state.selectedQuestions[this.state.activeMatter] || {}
                ).length
              }
              )
            </button>
            <button
              isactive={currentEditingOption === 2 ? "true" : "false"}
              onClick={() => this.setCurrentEditingOption(2)}
            >
              +add questões
            </button>
          </div>
        )}
      </div>
    );
  };

  addQuestion = (question) => {
    const { activeMatter } = this.state;
    const selectedQuestions = clone(this.state.selectedQuestions);

    if (!selectedQuestions[activeMatter]) {
      selectedQuestions[activeMatter] = {
        [question.codigo]: question,
      };
    } else if (selectedQuestions[activeMatter][question.codigo]) {
      delete selectedQuestions[activeMatter][question.codigo];
    } else {
      selectedQuestions[activeMatter][question.codigo] = question;
    }

    this.setState({ selectedQuestions }, () => {
      toast("Questão adicionada!", { type: "success" });
    });
  };

  removeQuestion = async (codigo) => {
    const result = await Swal.fire({
      title: "Remover Questão",
      text: "Deseja remover essa questão?",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
      showCancelButton: true,
      icon: "warning",
    });

    if (!result.value) return;

    const selectedQuestions = clone(this.state.selectedQuestions);

    delete selectedQuestions[this.state.activeMatter][codigo];

    this.setState({ selectedQuestions });
  };

  doSearch = async (query) => {
    if (!query) {
      toast("Insira algum texto para buscar pelas questões");
      return;
    }

    const popUp = toast("Buscando questões...", {
      type: "info",
      autoClose: false,
    });

    await Elastic.post("/questions/_search?size=200", {
      query: {
        bool: {
          should: [
            {
              match_phrase: {
                banca: query,
              },
            },
            {
              match_phrase: {
                orgao: query,
              },
            },
            {
              match_phrase: {
                prova: query,
              },
            },
            {
              match_phrase: {
                assuntos: query,
              },
            },
            {
              match_phrase: {
                enunciado: query,
              },
            },
            {
              match_phrase: {
                afirmacao: query,
              },
            },
            {
              match_phrase: {
                alternativas: query,
              },
            },
          ],
          minimum_should_match: 1,
        },
      },
    })
      .then((result) => {
        const questionsToAdd = result.data.hits.hits.map((question) => {
          question._source.alternativas = JSON.parse(
            question._source.alternativas
          );
          question._source.assunto = JSON.parse(question._source.assunto);

          return question._source;
        });

        if (questionsToAdd.length < 1) {
          toast("Nenhum resultado encontrado.", { type: "error" });
        }

        this.setState({ questionsToAdd });
      })
      .catch((e) => {
        console.error(e);
        toast("Um erro inesperado aconteceu.", { type: "error" });
        this.setState({ questionsToAdd: [] });
      })
      .finally(() => {
        toast.dismiss(popUp);
      });
  };

  validaDados = (data, referente) => {
    const mandatory = referente === this.state.modules[0]?.id;

    for (let i in data) {
      const item = data[i];

      switch (item.type) {
        case "title":
          if (!item.data) return "O preenchimento do titulo é obrigatório";
          break;
        case "sumary":
          if (!item.itens[0].data)
            return "O preenchimento de pelo menos 1 item do sumário é obrigatório";
          break;
        case "goals":
          if (!item.itens[0])
            return "O preenchimento de pelo menos 1 item dos objetivos é obrigatório";
          break;
        case "comment":
          if (!item.data && mandatory)
            return "O preenchimento do texto motivacional é obrigatório.";
          break;
        case "topic":
          if (!item.itens[0].data || !item.itens[0].itens[0].data)
            return "O preenchimento de pelo menos 1 topico é obrigatório, incluindo o titulo";
          break;
        case "thought-time":
          if (!item.itens[0])
            return "O preenchimento de pelo menos 1 item das perguntas para reflexão é obrigatório";
          break;
        case "bibliography":
          if (!item.itens[0].text)
            return "O preenchimento de pelo menos 1 item da bibliografia é obrigatório";
          break;
        default:
          break;
      }
    }
  };

  saveChanges = async (props) => {
    let status = true;

    try {
      if (!this.state.activeMatter) {
        await Swal.fire({
          title: "Selecione um modulo antes de salvar!",
          icon: "error",
        });
        return false;
      }

      const { showConfimModal } = props;

      if (!this?.props?.location?.state?.service?.codigo) {
        toast(
          "Atenção: Nenhum Pedido de Serviço foi encontrado, tente fechar essa aba e abrir novamente.",
          { type: "error" }
        );
        return;
      } else if (!this?.props?.location?.state?.user?.id) {
        toast(
          "Atenção: Nenhum Usuario foi encontrado, tente fechar essa aba e abrir novamente.",
          { type: "error" }
        );
        return;
      }

      Swal.fire({
        title: "Salvando alterações...",
        html: `As alterações estão sendo salvas, por favor aguarde, isso pode demorar até 20 minutos.<br>Caso você queira, pode <strong>deixar essa aba aberta</strong> e <a href="https://profadmin.firebaseapp.com/" target="_blank">ir trabalhando em outra</a>`,
        icon: "info",
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      this.formContent[this.state.activeMatter] = clone(this.state.formContent);

      if (!this.state.activeMatter) return;

      const result = await saveContentData({
        data: clone(this.formContent[this.state.activeMatter]),
        referente: this.state.activeMatter,
        service: this?.props?.location?.state?.service?.codigo,
        responsavel: this?.props?.location?.state?.user?.id,
      });

      if (result) {
        toast(
          `As alterações do modulo ${this.state.activeMatter} foram salvas com sucesso.`,
          { type: "success" }
        );
      } else {
        toast(
          `Falha ao salvar alterações do modulo ${this.state.activeMatter}.`,
          {
            type: "error",
          }
        );
      }

      const data = clone(this.formContent[this.state.activeMatter]);

      const nome =
        this.state.activeMatter.charAt(this.state.activeMatter.length - 2) ===
        "m"
          ? "modulos"
          : "revisoes";
      const pilha = this?.props?.location?.state?.service?.objetoRef?.codigo;
      const materia = pilha.substr(0, 4);

      if (pilha && materia && nome) {
        const update = {};

        if (
          this.state.activeMatter === this.state.revisions[0].id &&
          this?.props?.location?.state?.service.objetoResultadoRef?.assunto
        ) {
          update.nome = this?.props?.location?.state?.service.objetoResultadoRef?.assunto;
        } else if (data[8].data) {
          update.nome = data[8].data;
        }

        if (data[9].data) {
          update.profAutor = data[9].data;
        }

        if (
          this.props.location?.state?.authorizationType ===
            userType.SUPERVISOR &&
          data[10] &&
          data[10].data
        ) {
          update.profRevisor = data[10].data;
        }

        if (
          this.state.selectedQuestions[this.state.activeMatter] !== undefined
        ) {
          update.questoes = Object.keys(
            this.state.selectedQuestions[this.state.activeMatter]
          );
        }

        if (this.state.activeMatter.slice(-2) === "r1") {
          for (let i = 1; i <= 3; i++) {
            const newReferente = `${this.state.activeMatter.slice(
              0,
              this.state.activeMatter.length - 2
            )}r${i}`;

            const materiaDoc = await db
              .doc(
                `materias/${materia}/pilhas/${pilha}/${nome}/${newReferente}`
              )
              .get();

            if (materiaDoc.exists) {
              await db
                .doc(
                  `materias/${materia}/pilhas/${pilha}/${nome}/${newReferente}`
                )
                .update(update);

              toast(
                `As questões do modulo ${newReferente} foram vinculadas com sucesso.`,
                { type: "success" }
              );
            } else {
              toast(`Falha ao vincular as questões do modulo ${newReferente}`, {
                type: "error",
              });
            }
          }
        } else {
          const materiaDoc = await db
            .doc(
              `materias/${materia}/pilhas/${pilha}/${nome}/${this.state.activeMatter}`
            )
            .get();

          if (materiaDoc.exists) {
            await db
              .doc(
                `materias/${materia}/pilhas/${pilha}/${nome}/${this.state.activeMatter}`
              )
              .update(update);

            toast(
              `As questões do modulo ${this.state.activeMatter} foram vinculadas com sucesso.`,
              { type: "success" }
            );
          } else {
            toast(
              `Falha ao vincular as questões do modulo ${this.state.activeMatter}`,
              {
                type: "error",
              }
            );
          }
        }
      } else {
        toast(
          `Falha ao vincular as questões do modulo ${this.state.activeMatter}`,
          {
            type: "error",
          }
        );
      }

      if (showConfimModal) {
        await Swal.fire({
          title: "Pronto!",
          text: "Todas as Informações foram salvas com sucesso.",
          icon: "success",
        });
      }
    } catch (e) {
      console.error(e);

      status = false;

      await Swal.fire({
        title: "Falha ao salvar alterações",
        html:
          "Por favor, aperte <strong>F12</strong> e envie um print da aba <strong>Console</strong> para o suporte.",
        icon: "error",
      });
    } finally {
      Swal.close();

      return status;
    }
  };

  finishServiceOrder = async () => {
    try {
      if (this.state.modules.length + 1 !== obJLength(this.formContent)) {
        toast("Revise todos os Modulos e Revisões antes de finalizar.", {
          type: "error",
        });
        return;
      }

      const saveResult = await Swal.fire({
        title: "Você salvou o conteudo?",
        html:
          "Ao concluir o pedido de serviço, os conteudo escritos <strong>NÃO SERÃO SALVOS</strong>, você salvou os conteudos escritos antes de concluir esse pedido de serviço?",
        confirmButtonText: "Sim, concluir pedido",
        cancelButtonText: "Não, ainda tenho que salvar",
        showCancelButton: true,
        icon: "warning",
      });

      if (saveResult.dismiss) return;

      const result = await Swal.fire({
        title: "Concluir Pedido",
        text: "Deseja concluir este Pedido de serviço?",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        showCancelButton: true,
        icon: "warning",
      });

      if (!result.value) return;

      this.formContent[this.state.activeMatter] = clone(this.state.formContent);

      let ok = true;
      for (let referente in this.formContent) {
        const validationResult = this.validaDados(
          clone(this.formContent[referente]),
          referente
        );

        if (referente && validationResult) {
          const moduloCode = referente
            .substr(referente.length - 2)
            .toUpperCase();

          toast(`${moduloCode} - ${validationResult}`, { type: "error" });

          ok = false;
        }
      }
      if (!ok) return;

      const { service } = this.props.location.state;

      this.setState({ isFinishing: true });

      await db
        .collection("pedidosDeServico")
        .doc(service.id)
        .update({ status: "Concluido", horarioConclusao: new Date() });

      toast("Pedido de serviço conluído!", {
        type: "info",
        onClose: () => {
          window.location.href = "/";
        },
      });
    } catch (error) {
      console.error({ error });
    } finally {
      this.setState({ isFinishing: false });
    }
  };

  toggleApprovedStatus = async (approved = false) => {
    try {
      const { service } = this.props.location.state;

      if (this.state.modules.length + 1 !== obJLength(this.formContent)) {
        toast("Revise Todos os Modulos e Revisões antes de aprovar.", {
          type: "error",
        });
        return;
      }

      const saveResult = await Swal.fire({
        title: "Você salvou o conteudo?",
        html: `Ao ${
          approved ? "aprovar" : "reprovar"
        } o pedido de serviço, os conteudo escritos <strong>NÃO SERÃO SALVOS</strong>, você salvou os conteudos escritos antes de ${
          approved ? "aprovar" : "reprovar"
        } esse pedido de serviço?`,
        confirmButtonText: "Sim, continuar",
        cancelButtonText: "Não, ainda tenho que salvar",
        showCancelButton: true,
        icon: "warning",
      });

      if (saveResult.dismiss) return;

      const result = await Swal.fire({
        title: approved ? "Aprovar" : "Reprovar",
        text: `Deseja mesmo ${
          approved ? "aprovar" : "reprovar"
        } esse Pedido de serviço?`,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        showCancelButton: true,
        icon: "warning",
      });

      if (!result.value) return;

      this.setState({ isChangingApprovedStatus: true });

      if (approved) {
        Swal.fire({
          title: "Criando Arquivos...",
          html: `Os arquivos estão sendo criados, por favor aguarde, isso pode demorar até 20 minutos.<br>Caso você queira, pode <strong>deixar essa aba aberta</strong> e <a href="https://profadmin.firebaseapp.com/">ir trabalhando em outra</a>`,
          icon: "info",
          allowEscapeKey: false,
          allowEnterKey: false,
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: false,
        });

        for (let referente in this.formContent) {
          if (referente.slice(-2) === "r1") {
            for (let i = 2; i <= 3; i++) {
              this.formContent[
                referente.slice(0, referente.length - 2) + `r${i}`
              ] = this.formContent[referente];
            }

            break;
          }
        }

        for (let referente in this.formContent) {
          const data = clone(this.formContent[referente]);

          const html = htmlContent(data);

          await storage
            .ref()
            .child(
              `materias/${service.nomeMateria}/${service.objetoRef.codigo}/main/${referente}.html`
            )
            .putString(html, "raw", {
              contentType: "text/html",
            });
        }
      }

      Swal.fire({
        title: "Aprovando...",
        text: "Isso pode levar alguns minutos, por favor aguarde.",
        icon: "info",
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      await db
        .collection("pedidosDeServico")
        .doc(service.id)
        .update({
          status: approved ? "Aprovado" : "Reprovado",
          horarioAprovacao: new Date(),
        });

      await Swal.fire({
        title: "Sucesso!",
        text: "Pedido de Serviço aprovado.",
        icon: "success",
      });

      this.props.history.push(Routes.HOME);
    } catch (error) {
      console.error(error);
    } finally {
      Swal.close();
      this.setState({ isChangingApprovedStatus: false });
    }
  };

  quit = async () => {
    const result = await Swal.fire({
      title: "Sair",
      text:
        "Ao sair do pedido de serviço ativo ele ficará disponível no menu para outros professores. Deseja realmente sair?",
      confirmButtonText: "Sim, salvar e sair",
      cancelButtonText: "Sem, sair SEM salvar",
      showCancelButton: true,
      icon: "warning",
      showCloseButton: true,
    });

    if (result.dismiss && result.dismiss !== "cancel") return;

    const { service } = this.props.location.state;

    if (result.value) {
      await this.saveChanges({
        showConfimModal: true,
      });
    }

    await db.collection("pedidosDeServico").doc(service.id).update({
      status: "Aberto",
      prestadorID: null,
    });

    window.location.href = "/home";
  };

  contentForm = () => (
    <div className={styles["div-spacing"]}>
      {this.state.currentViewOption !== "revisoes" && (
        <div className={styles["div-tiny-space"]}>
          <TextField
            fullWidth
            margin="dense"
            label="Assunto"
            value={this.state.formContent[8].data}
            onChange={(e) =>
              this.handleContentChange("subject", e.target.value, [8])
            }
          />
        </div>
      )}
      <div className={styles["div-tiny-space"]}>
        <TextField
          fullWidth
          margin="dense"
          label="Professor Responsável"
          value={this.state.formContent[9].data}
          onChange={(e) =>
            this.handleContentChange("instructor", e.target.value, [9])
          }
        />
      </div>
      {this.props.location?.state?.authorizationType ===
        userType.SUPERVISOR && (
        <div className={styles["div-tiny-space"]}>
          <TextField
            fullWidth
            margin="dense"
            label="Revisor"
            value={this.state.formContent[10].data}
            onChange={(e) =>
              this.handleContentChange("reviewer", e.target.value, [10])
            }
          />
        </div>
      )}
      <div className={styles["div-tiny-space"]}>
        <TextField
          fullWidth
          margin="dense"
          label="Titulo"
          value={this.state.formContent[0].data}
          onChange={(e) =>
            this.handleContentChange("title", e.target.value, [0])
          }
        />
      </div>
      <div>
        <span>Sumário</span>
        {this.state.formContent[1].itens.map((item, key) => (
          <div className={styles["div-sumary"]} key={key}>
            <TextField
              fullWidth
              margin="dense"
              value={item.data}
              onChange={(e) =>
                this.handleContentChange("sumary", e.target.value, [1, key])
              }
            />
            <div className={styles["div-padding-left"]}>
              {item.itens.map((subItem, subKey) => {
                return (
                  <TextField
                    key={subKey}
                    fullWidth
                    margin="dense"
                    value={subItem}
                    onChange={(e) =>
                      this.handleContentChange("sumary-item", e.target.value, [
                        1,
                        key,
                        subKey,
                      ])
                    }
                  />
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <div>
        <span>Objetivos de Aprendizado</span>
        {this.state.formContent[2].itens.map((item, key) => (
          <TextField
            key={key}
            fullWidth
            margin="dense"
            value={item}
            onChange={(e) =>
              this.handleContentChange("goals", e.target.value, [2, key])
            }
          />
        ))}
      </div>
      <div className={styles["div-tiny-space"]}>
        <TextField
          fullWidth
          multiline
          margin="dense"
          label="Texto Motivacional"
          value={this.state.formContent[3].data}
          onChange={(e) =>
            this.handleContentChange("comment", e.target.value, [3])
          }
        />
      </div>
      {this.state.formContent[4].itens.map((item, key) => (
        <div key={key} style={{ display: "flex", alignItems: "center" }}>
          <div style={{ width: "95%" }}>
            <TextField
              fullWidth
              margin="dense"
              placeholder="Titulo do Tópico"
              value={item.data}
              onChange={(e) =>
                this.handleContentChange("topic", e.target.value, [4, key])
              }
            />
            <QuillComponent itemKey={key} classes={styles["div-default"]} />
          </div>
          <div style={{ marginLeft: "5px", width: "5%" }}>
            <button
              className={styles["save-button"]}
              onClick={() => this.removeTopic(key)}
            >
              X
            </button>
          </div>
        </div>
      ))}
      <div>
        <button onClick={this.addTopic} className={styles["save-button"]}>
          Adicionar Tópico
        </button>
      </div>
      <div>
        <span>Perguntas para Reflexão</span>
        {this.state.formContent[5].itens.map((item, key) => (
          <TextField
            key={key}
            fullWidth
            margin="dense"
            value={item}
            onChange={(e) =>
              this.handleContentChange("thought-time", e.target.value, [5, key])
            }
          />
        ))}
      </div>
      <div className={styles["div-two-fields"]}>
        <span>Glossário</span>
        {this.state.formContent[6].itens.map((item, key) => (
          <div key={key}>
            <TextField
              margin="dense"
              placeholder="Palavra"
              value={item.word}
              onChange={(e) =>
                this.handleContentChange("glossary", e.target.value, [
                  6,
                  key,
                  "word",
                ])
              }
            />
            <TextField
              margin="dense"
              placeholder="Significado"
              value={item.meaning}
              onChange={(e) =>
                this.handleContentChange("glossary", e.target.value, [
                  6,
                  key,
                  "meaning",
                ])
              }
            />
          </div>
        ))}
      </div>
      <div className={styles["div-two-fields"]}>
        <span>Bibliografia</span>
        {this.state.formContent[7].itens.map((item, key) => (
          <div key={key}>
            <TextField
              margin="dense"
              placeholder="Texto"
              value={item.text}
              onChange={(e) =>
                this.handleContentChange("bibliography", e.target.value, [
                  7,
                  key,
                  "text",
                ])
              }
            />
            <TextField
              margin="dense"
              placeholder="Link"
              value={item.link}
              onChange={(e) =>
                this.handleContentChange("bibliography", e.target.value, [
                  7,
                  key,
                  "link",
                ])
              }
            />
          </div>
        ))}
      </div>
    </div>
  );

  addTopic = () => {
    const formContent = this.formContent[this.state.activeMatter];

    formContent[4].itens.push(Topic());

    this.addedTopic = true;

    this.setState({ formContent });
  };

  handleContentChange = (type, value, keys) => {
    const formContent = this.formContent[this.state.activeMatter];

    switch (type) {
      case "title":
      case "comment":
      case "subject":
      case "instructor":
      case "reviewer":
        formContent[keys[0]].data = value;
        break;
      case "sumary":
        formContent[keys[0]].itens[keys[1]].data = value;
        break;
      case "sumary-item":
        formContent[keys[0]].itens[keys[1]].itens[keys[2]] = value;
        break;
      case "goals":
      case "thought-time":
        formContent[keys[0]].itens[keys[1]] = value;
        break;
      case "glossary":
      case "bibliography":
        formContent[keys[0]].itens[keys[1]][keys[2]] = value;
        break;
      case "topic":
        formContent[keys[0]].itens[keys[1]].data = value;
        break;
      case "subtopic":
        formContent[keys[0]].itens[keys[1]].itens[0].itens[0].data = value.data;
        formContent[keys[0]].itens[keys[1]].itens[0].itens[0].htmls =
          value.htmls;
        formContent[keys[0]].itens[keys[1]].itens[0].itens[0].steps =
          value.steps;
        break;
      default:
        break;
    }

    this.setState({ formContent });
  };

  removeTopic = async (key) => {
    if (key < 1) {
      toast("Ao menos 1 tópico deve ser preenchido", { type: "error" });
      return;
    }

    const result = await Swal.fire({
      title: "Tem certeza?",
      html:
        "Esse topico será excluido e <b>não poderá ser recuperado</b>, tem certeza de que dejesa exclui-lo?",
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Não, cancelar",
      showCancelButton: true,
    });

    if (result.dismiss) return;

    const formContent = clone(this.formContent[this.state.activeMatter]);

    formContent[4].itens.splice(key, 1);

    this.formContent[this.state.activeMatter] = formContent;

    this.setState({ formContent });
  };

  render() {
    const { service, authorizationType } = this.props.location?.state;

    const {
      currentEditingOption,
      allMatters,
      activeMatter,
      isSaving,
      loadingModules,
      isFinishing,
      isChangingApprovedStatus,
      currentViewOption,
      selectedQuestions,
      questionsToAdd,
      service: serviceFromState,
    } = this.state;

    const currentData = allMatters.find((matter) => matter.id === activeMatter);

    if (loadingModules) {
      return (
        <div className="d-flex justify-content-center mt-2">
          <ActivityIndicator />
        </div>
      );
    }

    const getBtns = () => {
      const { prestadorID } = this.state.service;

      if (authorizationType === userType.SUPERVISOR) {
        if (
          this.state.service.status === "Atribuido" &&
          this?.props?.location?.state?.user?.id !== prestadorID
        ) {
          return <></>;
        }

        return (
          <>
            <button
              onClick={() =>
                this.saveChanges({
                  showConfimModal: true,
                })
              }
              disabled={isSaving}
              className={styles["save-button"]}
            >
              {isSaving ? "Salvando" : "Salvar alterações"}
            </button>

            <div className="mr-2"></div>

            <button
              onClick={() => this.toggleApprovedStatus(true)}
              disabled={isChangingApprovedStatus}
              className={styles["save-button"]}
              style={{ backgroundColor: "#ff9100" }}
            >
              Aprovar
            </button>

            <div className="mr-2"></div>

            <button
              onClick={() => this.toggleApprovedStatus(false)}
              disabled={isChangingApprovedStatus}
              className={styles["save-button"]}
            >
              Reprovar
            </button>
          </>
        );
      } else {
        if (this.state.service.status !== "Atribuido") {
          return <></>;
        }

        return (
          <>
            <button
              onClick={this.finishServiceOrder}
              disabled={isFinishing}
              className={styles["save-button"]}
              style={{ backgroundColor: "#ff9100" }}
            >
              {isFinishing ? "Salvando" : "Concluir pedido de serviço"}
            </button>

            <div className="mr-2"></div>

            <button
              onClick={() =>
                this.saveChanges({
                  showConfimModal: true,
                })
              }
              disabled={isSaving}
              className={styles["save-button"]}
            >
              {isSaving ? "Salvando" : "Salvar alterações"}
            </button>

            <div className="mr-2"></div>

            <button
              onClick={this.quit}
              disabled={isSaving}
              className={styles["quit-button"]}
            >
              Sair
            </button>
          </>
        );
      }
    };

    return (
      <div
        style={{
          pointerEvents: isFinishing ? "none" : "auto",
        }}
        className={` ${styles["modules-container"]} container`}
      >
        <div className="d-flex justify-content-between">
          {`${service?.nomeMateria} - ${
            service.objetoResultadoRef?.assunto ?? ""
          }`}
          <div className="d-flex">{getBtns()}</div>
        </div>
        <div className={`${styles.headers}`}>
          {this.renderModulesHeader()}
          {this.renderRevisionsHeader()}
        </div>
        {currentEditingOption === 0 && (
          <div>
            <button
              onClick={() => {
                this.setState({ isAudioModalOpen: true });
              }}
              className="btn"
              title="Áudio"
            >
              <MDBIcon icon="microphone" />
            </button>
          </div>
        )}
        {currentEditingOption === 0 && this.contentForm()}
        {currentEditingOption === 1 && (
          <QuestionTable
            questions={
              selectedQuestions[activeMatter]
                ? Object.values(selectedQuestions[activeMatter])
                : []
            }
            activeMatter={activeMatter}
            removeQuestion={this.removeQuestion}
            editQuestion={(codigo) => {
              this.setState({ isQuestionModalOpen: codigo });
            }}
          />
        )}
        {currentEditingOption === 2 && (
          <>
            <div>
              <button
                onClick={() => this.setState({ isQuestionModalOpen: true })}
                className="btn"
                title="Questão"
              >
                <MDBIcon icon="plus" />
              </button>
            </div>
            <QuestionTable
              search={(query) => this.doSearch(query)}
              questions={questionsToAdd.filter((question) => {
                if (!selectedQuestions[activeMatter]) return true;

                if (
                  !Object.keys(selectedQuestions[activeMatter]).includes(
                    question.codigo
                  )
                ) {
                  return true;
                }

                return false;
              })}
              activeMatter={activeMatter}
              addQuestion={this.addQuestion}
            />
          </>
        )}
        <footer className="mt-2 mb-4 ml-auto"></footer>
        {this.state.isAudioModalOpen && (
          <AudioModal
            open={this.state.isAudioModalOpen}
            module={currentData}
            service={serviceFromState}
            currentViewOption={currentViewOption}
            onRequestClose={() => {
              this.setState({ isAudioModalOpen: false });
            }}
            onAudioUpdated={async ({ audios, module }) => {
              if (currentViewOption === "modulos") {
                const { modules } = this.state;

                const oldModule = modules.find((item) => item.id === module.id);
                oldModule.audios = audios;

                await db
                  .doc(
                    [
                      "materias",
                      this.state.activeMatter.substr(0, 4),
                      "pilhas",
                      this.state.activeMatter.substr(0, 7),
                      "modulos",
                      this.state.activeMatter,
                    ].join("/")
                  )
                  .update({ audios });

                this.setState({ modules });
              } else {
                const { revisions } = this.state;

                const oldModule = revisions.find(
                  (item) => item.id === module.id
                );
                oldModule.audios = audios;

                await db
                  .doc(
                    [
                      "materias",
                      this.state.activeMatter.substr(0, 4),
                      "pilhas",
                      this.state.activeMatter.substr(0, 7),
                      "revisoes",
                      this.state.activeMatter,
                    ].join("/")
                  )
                  .update({ audios });

                this.setState({ revisions });
              }
            }}
          />
        )}
        {this.state.isQuestionModalOpen && (
          <div
            className={modalStyles.container}
            onClick={(e) => {
              if (e.target !== e.currentTarget) return;
              this.setState({ isQuestionModalOpen: false });
            }}
          >
            <div className={modalStyles["modal-body"]}>
              <QuestionModal
                setState={(value) => this.setState(value)}
                questionsSelected={this.state.selectedQuestions}
                questionsToAdd={this.state.questionsToAdd}
                open={!!this.state.isQuestionModalOpen}
                state={this?.props?.location?.state}
                activeMatter={this.state.activeMatter}
                onClose={this.closeModal}
                defaultValues={() => {
                  if (typeof this.state.isQuestionModalOpen === "string") {
                    return this.state.selectedQuestions[
                      this.state.activeMatter
                    ][this.state.isQuestionModalOpen];
                  }

                  return null;
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

Editor.contextType = userContext;

export default Editor;
